import { useState } from 'react';

function CalendarMonth({ events, loading, onEventClick, compact }) {
  const [viewDate, setViewDate] = useState(new Date());

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();

  function prevMonth() {
    setViewDate(new Date(year, month - 1, 1));
  }

  function nextMonth() {
    setViewDate(new Date(year, month + 1, 1));
  }

  function goToday() {
    setViewDate(new Date());
  }

  const firstDay = new Date(year, month, 1);
  const startOffset = firstDay.getDay();

  // Build grid cells
  const cells = [];
  if (compact) {
    // Show current week and next week (14 days)
    const now = new Date();
    const dayOfWeek = now.getDay();
    const weekStart = new Date(now);
    weekStart.setDate(now.getDate() - dayOfWeek);
    weekStart.setHours(0, 0, 0, 0);
    for (let i = 0; i < 14; i++) {
      const date = new Date(weekStart);
      date.setDate(weekStart.getDate() + i);
      cells.push(date);
    }
  } else {
    // Full 6-week grid
    const gridStart = new Date(year, month, 1 - startOffset);
    for (let i = 0; i < 42; i++) {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + i);
      cells.push(date);
    }
  }

  // Index events by date string for fast lookup
  const eventsByDate = {};
  events.forEach((event) => {
    if (event.allDay) {
      // Span all days from start to end (exclusive end for all-day)
      const d = new Date(event.start);
      const endDate = new Date(event.end);
      while (d < endDate) {
        const key = dateKey(d);
        if (!eventsByDate[key]) eventsByDate[key] = [];
        eventsByDate[key].push(event);
        d.setDate(d.getDate() + 1);
      }
    } else {
      const key = dateKey(event.start);
      if (!eventsByDate[key]) eventsByDate[key] = [];
      eventsByDate[key].push(event);
    }
  });

  function dateKey(d) {
    return d.toLocaleDateString('en-US', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' });
  }

  const today = new Date();
  const todayKey = dateKey(today);
  const monthLabel = viewDate.toLocaleDateString('en-US', { timeZone: 'America/Chicago', month: 'long', year: 'numeric' });
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <section className={`card calendar-month-section${compact ? ' cal-compact' : ''}`}>
      {compact ? (
        <div className="cal-header">
          <h2>This Week &amp; Next</h2>
        </div>
      ) : (
        <div className="cal-header">
          <button className="cal-nav-btn" onClick={prevMonth}>&lt;</button>
          <h2 onClick={goToday}>{monthLabel}</h2>
          <button className="cal-nav-btn" onClick={nextMonth}>&gt;</button>
        </div>
      )}
      {loading ? (
        <p className="loading">Loading calendar...</p>
      ) : (
        <div className="cal-grid">
          {dayNames.map((d) => (
            <div key={d} className="cal-day-name">{d}</div>
          ))}
          {cells.map((date, i) => {
            const key = dateKey(date);
            const isCurrentMonth = date.getMonth() === month;
            const isToday = key === todayKey;
            const dayEvents = eventsByDate[key] || [];

            return (
              <div
                key={i}
                className={`cal-cell${!isCurrentMonth ? ' other-month' : ''}${isToday ? ' today' : ''}`}
              >
                <span className="cal-date-num">{date.getDate()}</span>
                <div className="cal-events">
                  {dayEvents.slice(0, 3).map((event, j) => (
                    <div
                      key={event.id + '-' + j}
                      className="cal-event-chip"
                      onClick={() => onEventClick(event)}
                      title={event.summary}
                    >
                      {event.summary}
                    </div>
                  ))}
                  {dayEvents.length > 3 && (
                    <div className="cal-event-more">+{dayEvents.length - 3} more</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default CalendarMonth;
